import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Oklahoma City, OK?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through an Oklahoma City post office or acceptance clerk can take 2–6 months, especially during busy travel seasons. For energy executives with last-minute Dubai trips, Tinker AFB families with PCS orders, and families with upcoming vacations, that timeline is simply not viable.",
  },
  {
    q: "I am an energy executive in OKC with a trip to Dubai in 5 days. Can you help?",
    a: "Absolutely — this is one of the most common scenarios we handle for Oklahoma City professionals. Energy industry travel to Dubai, Abu Dhabi, London, and Calgary often gets booked with very little lead time. Contact us immediately at 877-253-0084 and we will assess your eligibility for our emergency processing option. Most OKC energy professionals in this situation ship their documents overnight and receive their passport in 2–5 business days.",
  },
  {
    q: "Our Tinker AFB family has PCS orders to Germany. Can you process military passports?",
    a: "Yes — military PCS passport processing is a specialty of ours. We handle Tinker AFB families going to Germany, Japan, South Korea, and the UK regularly. We coordinate dependent passport renewals and child passport applications to meet your report date. Bring your PCS orders for priority handling. Contact us as soon as your orders arrive.",
  },
  {
    q: "Can I renew my Oklahoma City passport without visiting an acceptance facility?",
    a: "Yes. If your most recent passport was issued when you were 16 or older, is undamaged, and was issued within the last 15 years, you can renew by mail — no facility visit needed. Start online, ship your documents overnight from any OKC UPS or FedEx location, and we handle the rest.",
  },
  {
    q: "Do I need to visit the Oklahoma City Passport Agency for urgent processing?",
    a: "Not with Fast Passport Center. The Oklahoma City Passport Agency at 301 NW 6th Street is right downtown, but appointments are often unavailable or weeks out. We provide a faster, simpler path through our reserved agency submission slots — you ship documents overnight from OKC and we handle the submission, no agency visit required.",
  },
  {
    q: "How quickly can Moore and Yukon residents receive an expedited passport?",
    a: "Moore and Yukon travelers have the same access to our expedited services as downtown OKC residents. Since we operate remotely, your physical location in the OKC metro does not affect processing speed. Ship your documents overnight from any Oklahoma County location, and we handle the rest. Most OKC metro clients receive their passports within 2–9 business days.",
  },
  {
    q: "What documents do I need for an expedited passport from Oklahoma City?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Can OU Health medical professionals get a passport fast for a conference?",
    a: "Yes. Medical conference travel is one of our most frequent OKC client categories. Conference acceptance letters often arrive with 3–4 weeks of lead time. We expedite renewals for medical professionals and guide first-time applicants through the acceptance clerk process. Keep your conference acceptance letter as proof of urgent travel.",
  },
];

export default function OKCFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Oklahoma City and Central Oklahoma travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}